export default __webpack_public_path__ + "static/media/keto_dangers@2x.8365d2f7.jpg";